import { fetchBaseQuery } from '@reduxjs/toolkit/query';
import { createApi } from '@reduxjs/toolkit/query/react';
import { config } from '../../../config';
import { decodeResponse, validateResponse } from '../../app/api/responseUtil';
import { prepareHeaders } from '../../app/api/utils';
import { FinishedVehicleQueryResult, NaturalLanguageQuery } from '../dataqueries/dataQuery.types';
import { FinishedVehicleQueryResultCodec } from './dataQueryApi.types';
import { mapToApiNaturalLanguageQuery, mapToFinishedVehicleQueryResult } from './dataQueryMapper';

export const OOB_INSPECTOR_DATA_QUERY_PATH = '/finished-vehicle-logistic-data-queries';

export const dataQueryApi = createApi({
    reducerPath: 'dataQueryApi',
    baseQuery: fetchBaseQuery({ baseUrl: config.backend.OOB_INSPECTOR_SERVICE, prepareHeaders }),
    tagTypes: [],
    endpoints: (builder) => ({
        postDataQuery: builder.mutation<FinishedVehicleQueryResult, NaturalLanguageQuery>({
            query: (queryParameters) => ({
                method: 'POST',
                url: OOB_INSPECTOR_DATA_QUERY_PATH,
                body: mapToApiNaturalLanguageQuery(queryParameters),
                validateStatus: validateResponse(FinishedVehicleQueryResultCodec),
            }),
            transformResponse: decodeResponse(FinishedVehicleQueryResultCodec, mapToFinishedVehicleQueryResult),
        }),
    }),
});

export const { usePostDataQueryMutation } = dataQueryApi;
